import { apiPath, apiUrl } from '../constants';

export const BASE_UPLOAD_PATH = `/${apiPath}/upload/`;
export const APK_UPLOAD_PATH = `/${apiPath}/upload/file/`;
export const AAB_UPLOAD_PATH = `/${apiPath}/upload/aab/`;
